module.exports = __webpack_public_path__ + "static/media/logoSmall.f8580f20.svg";